"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const core_1 = require("@bem-react/core");
const desktop_1 = require("@yandex-lego/components/Button/desktop");
const icon_1 = require("./size/icon");
const dl_default_1 = require("./view/dl-default");
// eslint-disable-next-line import/prefer-default-export
exports.Button = (0, core_1.compose)((0, core_1.composeU)(desktop_1.withSizeM, icon_1.withSizeIcon), (0, core_1.composeU)((0, core_1.composeU)(desktop_1.withViewClear, dl_default_1.withViewDLDefault)))(desktop_1.Button);
